import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgToastService } from 'ng-angular-popup';
import { StatusBadgeComponent } from '@/app/components/shared/status-badge/status-badge.component';
import { ViewDetailAddendumComponent } from './view-detail-addendum/view-detail-addendum.component';
@Component({
  selector: 'app-rfp-clarification-addendums',
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    StatusBadgeComponent,
    ViewDetailAddendumComponent,
  ],
  templateUrl: './rfp-clarification-addendums.component.html',
  styleUrl: './rfp-clarification-addendums.component.css',
})
export class RfpClarificationAddendumsComponent implements OnInit {
  isDialogOpen: boolean = false;

  projectId: number;
  rfpId: number;

  addendums: any;
  selectedAddendum: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private tenderingService: TenderingService,
    private toast: NgToastService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.projectId = params.get('projectId')
        ? parseInt(params.get('projectId'))
        : null;
      this.rfpId = params.get('rfpId') ? parseInt(params.get('rfpId')) : null;
    });

    console.log('RfpClarificationAddendumsComponent');
    this.fetchAddendums();
  }

  fetchAddendums() {
    this.tenderingService
      .getRFPAddendums(this.projectId, this.rfpId)
      .subscribe({
        next: (response) => {
          if (response?.meta?.success) {
            this.addendums = response.data;
            return;
          }
          // this.toast.warning('Error while fetching addendums', 'DANGER', 4000);
        },
        error: (error) => {
          console.error('Error fetching addendums:', error);
          // this.toast.danger('Error while fetching addendums', 'DANGER', 4000);
        },
      });
  }
  openDialog(addendum: any) {
    this.selectedAddendum = addendum;
    this.isDialogOpen = !this.isDialogOpen;
  }
}
